import api from "../../storage/api";

const Voting = (props) => {
  return (
    <section className="voting" style={{background: `url(${api.apiImages}${props.bg}) no-repeat center center/cover`}}>
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            Голосование за <span>обновление</span>
          </h2>
          <p className="common-title__subtitle">
            ты напрямую можешь повлиять на судьбу сервера: покупая донат, есть
            возможность проголосовать за следующее обновление
          </p>
        </div>
        <div className="voting-body">
          <h3 className="voting-title">{props.content.title}</h3>
          <div className="voting-options">
            {props.content.options.map((item, key) => (
              <div className={item.winner ? "voting-option voting-option_winner" : "voting-option"} key={key}>
                <div className="voting-option__bg" style={{width: item.votes + "%"}}></div>
                <p className="voting-option__description">
                  {item.description}
                </p>
                <span className="voting-option__result">{item.votes}%</span>
              </div>
            ))}
          </div>
          <div className="voting-description-title">
            <span className="voting-description-title__text">
              Как работает голосование?
            </span>
          </div>
          <p className="voting-description">
            В корзине, во время оформления заказа, ты можешь проголосовать за
            обновление. Чем больше сумма покупки, тем больше баллов будет
            добавлено к выбранному вами варианту. Например, донат стоимостью 100
            ₽ добавит 100 баллов за выбранный вариант.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Voting;
